module.exports = __webpack_public_path__ + "img/searchInput@2x.dcfd36a1.jpg";